import { Box, createStyles } from '@mantine/core';
import { Text } from '@repo/foundations';

const useStyles = createStyles((theme) => ({
	container: {
		margin: `0 ${theme.spacing['2xs']}`,
		width: `calc(100% - (2 * ${theme.spacing['2xs']}))`,
		padding: `${theme.spacing['2xs']}`,
	},
}));

export function SelectorItemError({ children }: { children: React.ReactNode }) {
	const { classes } = useStyles();

	return (
		<Box className={classes.container}>
			<Text size="sm" color="text/critical/default">
				{children}
			</Text>
		</Box>
	);
}
